import axios from 'axios';

const API_URLS = {
    production: 'https://centro-infantil-mijardin.onrender.com/api/cartas',
    development: 'http://localhost:5000/api/cartas'
};

const API_URL = (process.env.NODE_ENV === 'production' ? API_URLS.production : API_URLS.development).replace(/\/+$/, '');

axios.defaults.withCredentials = true;

// Servicios para Cartas de Compromiso
export const obtenerCartas = async () => {
    try {
        const response = await axios.get(`${API_URL}/recuperar_cartas`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener cartas de compromiso:', error);
        throw error.response?.data || new Error('Error al obtener cartas de compromiso');
    }
};

export const obtenerCartaPorId = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/recuperar_cartas/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener carta de compromiso:', error);
        throw error.response?.data || new Error('Error al obtener carta de compromiso');
    }
};

export const crearCarta = async (datosCarta) => {
    try {
        const response = await axios.post(`${API_URL}/crear_carta`, datosCarta, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al crear carta de compromiso:', error);
        throw error.response?.data || new Error('Error al crear carta de compromiso');
    }
};

export const actualizarCarta = async (id, datosActualizados) => {
    try {
        const response = await axios.put(`${API_URL}/modificar_carta/${id}`, datosActualizados, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al actualizar carta de compromiso:', error);
        throw error.response?.data || new Error('Error al actualizar carta de compromiso');
    }
};

export const eliminarCarta = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/eliminar_cartas/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al eliminar carta de compromiso:', error);
        throw error.response?.data || new Error('Error al eliminar carta de compromiso');
    }
};

// Servicios para Cláusulas
export const actualizarClausula = async (id_carta, id_clausula, data) => {
    try {
        const response = await axios.put(`${API_URL}/editar_cartas/${id_carta}/clausulas/${id_clausula}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al actualizar cláusula:', error);
        throw error;
    }
};

export const eliminarClausula = async (id_carta, id_clausula) => {
    try {
        const response = await axios.delete(`${API_URL}/eliminar_cartas/${id_carta}/clausulas/${id_clausula}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al eliminar cláusula:', error);
        throw error;
    }
};

export const agregarClausula = async (id_carta, data) => {
    try {
        const response = await axios.post(`${API_URL}/agregar_cartas/${id_carta}/clausulas`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al agregar cláusula:', error);
        throw error;
    }
};